<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('reports.orderStatus')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="sales-report">
      <!-- Status Report -->
      <div class="col-md-12 mar-bt-15">
        <div class="pull-left mar-rt-10">
          <span class="pad-rg-5">{{$t('dashboard.selectMethod')}}</span>
          <select class="form-control inline-auto white" v-model="orders.method" v-on:change="getOrders()">
            <!-- <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option> -->
            <template v-for="method in methods"> 
              <option
                :key="method.key"
                :label="$t('settingCompany.'+ method.key.toLowerCase())"
                :value="method.key">
                {{method.label}}</option>
            </template>
          </select>
        </div>
        <p :class="{'pull-left': true, 'sales-rectify-date-picker-padding' : showMethods}">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions1">
          </el-date-picker>
        </p>
        <div class="pull-left search-button-reports">
          <div class="btn btn-icon btn-info btn-search" @click="updateData" :title="$t('reports.search')"><i class="ti-search"></i></div>
          <div class="btn btn-icon btn-xls mar-lt-20" @click="downloadReport" :title="$t('reports.export')">
            {{$t('general.download_xls') }} <img src="/static/img/export_xls.png">
          </div>
        </div>
        <div class="pull-right">
          <button type="submit" class="btn edit mar-rt-40" @click="editRows" :title="$t('general.edit')" >
            <i class="fa fa-pencil" @click="editGroup(group, idx)"></i>{{$t('general.edit')}}
          </button>
        </div>
      </div>
      <div class="col-md-12 custom-border" v-if="ordersTableData && editMode">
        <form>
          <div class="card">
            <div class="card-content total-pagination reports-center-columns">
              <el-table
                v-loading="loading"
                :data="[useStatuses]"
                class="report-sales custom-border">
                <el-table-column :width="120">
                  <template slot-scope="scope">
                    {{ $t('general.included') }}
                  </template>
                </el-table-column>
                <el-table-column v-for="(key, column) in useStatuses" 
                                :key="column"
                                :label="$t('ordersStatus.' + column)"
                                :min-width="120">
                  <template slot-scope="scope">
                    <p-checkbox
                      :key="column"
                      @input="{ useStatuses[column] = !useStatuses[column] }"
                      :checked="useStatuses[column]">
                    </p-checkbox>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </form>
      </div>
      
      <div class="col-md-12 custom-border" v-if="average.NEW">
        <div class="card">
          <div class="card-content total-pagination reports-center-columns">
            <el-table
              v-loading="loading"
              :data="[average]"
              class="report-sales custom-border">
              <el-table-column :width="120">
                <template slot-scope="scope">
                  {{ $t('reports.average') }}
                </template>
              </el-table-column>
              <el-table-column v-for="(column, key) in statuses" 
                              :key="key"
                              :label="$t('ordersStatus.' + column)"
                              :min-width="80">
                <template slot-scope="scope" v-if="average[column]">
                  {{ calcTime(average[column]['avg']) }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-content total-pagination reports-center-columns">
            <data-tables-server
              v-loading="loading"
              :data="ordersTableData"
              :search-def="{show: false}"
              :total="totalRecords"
              :pagination-props="paginationProps"
              class="report-sales custom-border"
              key="sales-table"
              ref="ordersTableData">
              <el-table-column :width="160" prop="token" :label="'ID '+$t('reports.order')" >
                <template slot-scope="scope">
                  {{ scope.row.id }} / {{ scope.row.token }}
                </template>
              </el-table-column>

              <el-table-column :width="200" prop="token" :label="$t('reports.checkOrder')">
                <template slot-scope="scope">
                  <p-checkbox
                    class="checkbox-color"
                    :v-model="excludeOrders"
                    :key="scope.row.id" 
                    :id="scope.row.id" 
                    @input="handleCheck(scope.row.id)"
                    checked>
                  </p-checkbox>
                </template>
              </el-table-column>

              <el-table-column v-for="(column, key) in statuses" 
                              :key="key"
                              :prop="String(key)"
                              :label="$t('ordersStatus.' + column)"
                              :min-width="80">
                <template slot-scope="scope">
                  <p v-if="scope.row.statuses_time && scope.row.statuses_time[column]"><span>{{ calcTime(scope.row.statuses_time[column]) }}</span></p>
                  
                  <div class="popoverWrapper">
                    <p v-if="scope.row.statuses" v-popover="{ name: (' ' + scope.row.id + column) }">{{separateDate(scope.row.statuses[column])}}</p>
                    <popover v-if="separateDate(scope.row.statuses[column]) != '--'" :name="(' ' + scope.row.id + column)" class="bottom" event="hover">
                      {{separateDateJustDate(scope.row.statuses[column])}}
                    </popover>
                  </div>
                </template>
              </el-table-column>

              <el-table-column :width="120" prop="statuses_time" :label="$t('settingCompany.custom')" >
                <template slot-scope="scope">
                  <div class="popoverWrapper" v-if="scope.row.statuses_time && scope.row.statuses_time['NEW_HOLD_PROCESSING']">
                    <p v-popover="{ name: (' ' + scope.row.id + '_NEW_HOLD_PROCESSING') }"><span>{{ calcTime(scope.row.statuses_time['NEW_HOLD_PROCESSING']) }}</span></p>
                    <popover :name="(' ' + scope.row.id + '_NEW_HOLD_PROCESSING')" class="bottom" event="hover">
                      {{ $t('ordersStatus.NEW') }} + {{ $t('ordersStatus.ON_HOLD') }} + {{ $t('ordersStatus.PROCESSING') }}
                    </popover>
                  </div>
                  <div class="popoverWrapper" v-if="scope.row.statuses_time && scope.row.statuses_time['PREPARED_TRANSPORT']">
                    <p v-popover="{ name: (' ' + scope.row.id + '_PREPARED_TRANSPORT') }"><span>{{ calcTime(scope.row.statuses_time['PREPARED_TRANSPORT']) }}</span></p>
                    <popover :name="(' ' + scope.row.id + '_PREPARED_TRANSPORT')" class="bottom" event="hover">
                      {{ $t('ordersStatus.PREPARED') }} + {{ $t('ordersStatus.TRANSPORT') }}
                    </popover>
                  </div>
                  <div class="popoverWrapper" v-if="scope.row.statuses_time && scope.row.statuses_time['TOTAL']">
                    <p v-popover="{ name: (' ' + scope.row.id + '_TOTAL') }"><span>{{ calcTime(scope.row.statuses_time['TOTAL']) }}</span></p>
                    <popover :name="(' ' + scope.row.id + '_TOTAL')" class="bottom" event="hover">
                      {{ $t('customers.total') }}
                    </popover>
                  </div>
                </template>
              </el-table-column>
            </data-tables-server>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import moment from 'moment'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import Popover from 'vue-js-popover'
Vue.use(Popover)
// import JsonExcel from 'vue-json-excel'
// Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    // GeneralTopBar,
    [DatePicker.name]: DatePicker
  },
  props: {
    isOrderStatus: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isOrderStatus () {
      if (this.isOrderStatus) {
        this.getOrders()
      }
    }
  },
  created () {
    const currentDate = new Date()
    const formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear()
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '_' + this.$t('reports.statusReport') + '_' + formattedDate + '.xlsx'
    this.verifyUserMethods()
  },
  data () {
    return {
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [
          moment().format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        method: 'delivery'
      },
      showMethods: false,
      methods: [],
      paginationProps: {
        layout: 'total'
        // layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions1: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      ordersTableData: [],
      average: [],
      statuses: [],
      totalRecords: null,
      editMode: false,
      useStatuses: {
        'ON_HOLD': true,
        'POSTPONED': true,
        'PROCESSING': true,
        'PREPARED': true,
        'AWAITING_TRANSPORT': true,
        'PICKED_UP_BY_DELIVERY': true,
        'TRANSPORT': true,
        'DELIVERED': true,
        'NOT_DELIVERED': true
      },
      excludeOrders: []
    }
  },
  methods: {
    separateDate (date) {
      if (date === '--') {
        return date
      }
      let txt = date.split(' ')
      return txt[1]
      // return txt[1] + '<span>' + txt[0] + '</span>'
    },
    separateDateJustDate (date) {
      if (date === '--') {
        return date
      }
      let txt = date.split(' ')
      return txt[0]
      // return txt[1] + '<span>' + txt[0] + '</span>'
    },
    calcSubst (column) {
      return column.substring(0, 3) === 'AVG'
    },
    calcSubst2 (column) {
      let a = column.substring(3)
      a = this.average[a]
      if (a) {
        return this.calcTime(a.avg)
      } else {
        return '--'
      }
    },
    paginationChanged (query) {
      if (query.type === 'page') this.getOrders(query)
      if (query.type === 'size') this.getOrders(query)
      if (query.type === 'sort') this.getOrders(query)
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    downloadReport (query) {
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.orders.valid[0],
        end_date: this.orders.valid[1]
      }
      const onlyUse = Object.keys(this.useStatuses).filter(status => {
        return this.useStatuses[status] === true
      })
      data.use_statuses = onlyUse
      if (this.orders.method && this.orders.method !== '') {
        data.method = this.orders.method.toUpperCase()
      }
      if (this.excludeOrders.length) {
        data.exclude_orders = this.excludeOrders
      } else {
        delete data.exclude_orders
      }
      this.loading = true
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1
      this.apiRequest('/reports/status/export?page=' + page + '&pageSize=' + pageSize, 'GET', data, response => {
        const link = document.createElement('a')
        link.href = response.file
        link.setAttribute('download', this.export_name)
        document.body.appendChild(link)
        link.click()
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    getOrders (query) {
      if (!this.isOrderStatus) {
        return
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.orders.valid[0],
        end_date: this.orders.valid[1]
      }
      const onlyUse = Object.keys(this.useStatuses).filter(status => {
        return this.useStatuses[status] === true
      })
      data.use_statuses = onlyUse
      if (this.orders.method && this.orders.method !== '') {
        data.method = this.orders.method.toUpperCase()
      }
      if (this.excludeOrders.length) {
        data.exclude_orders = this.excludeOrders
      } else {
        delete data.exclude_orders
      }
      this.loading = true
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1
      this.apiRequest('/reports/status?page=' + page + '&pageSize=' + pageSize, 'GET', data, response => {
        if (response.status === true) {
          this.ordersTableData = response.data.orders
          this.average = response.data.averages
          this.totalRecords = response.data.total
          this.statuses = response.data.statuses
          // this.statuses = []
          // for (const [key, element] of Object.entries(response.data.statuses)) {
          //   this.statuses.push(element)
          //   this.statuses.push('AVG' + element)
          // }
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.getOrders()
    },
    goToRecordOrder (row, event, column) {
      window.open(`/#/orders/view/${row.id}`)
    },
    currentDate () {
      return moment().format('DD-MM-YYYY') + '.xls'
    },
    calcTime (seconds) {
      let originalSeconds = seconds
      if (seconds <= 0) {
        seconds = seconds * (-1)
      }
      if (seconds === '' || seconds === 0) return '--'
      // var numyears = Math.floor(seconds / 31536000)
      var numdays = Math.floor((seconds % 31536000) / 86400)
      var numhours = Math.floor(((seconds % 31536000) % 86400) / 3600)
      var numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60)
      var numseconds = (((seconds % 31536000) % 86400) % 3600) % 60
      var total = ''
      if (originalSeconds <= 0) {
        total = '-'
      }
      if (numdays) total += parseInt(numdays) + 'd '
      if (numhours) total += parseInt(numhours) + 'h '
      if (numminutes) total += parseInt(numminutes) + 'm '
      if (numseconds) total += parseInt(numseconds) + 's '
      return total
    },
    editRows () {
      this.editMode = !this.editMode
    },
    handleCheck (id) {
      if (this.excludeOrders.includes(id)) {
        let index = this.excludeOrders.indexOf(id)
        this.excludeOrders.splice(index, 1)
      } else {
        this.excludeOrders.push(id)
      }
    }
  }
}
</script>
<style>
  .sales-report .bottom.vue-popover.dropdown-position-bottom {
    left: calc(50% - 90px) !important;
    top: calc(50% + 16px) !important;
    overflow: visible;
  }
  .sales-report .popoverWrapper {
    position: relative;
    overflow: visible;
  }
  .sales-report .cell .popoverWrapper>p {
    font-size: 14px;
    margin-top: 5px;
  }
  .report-sales .cell {
    overflow: visible !important;
  }
  .report-sales .cell p {
    margin: 0;
  }
  .report-sales .cell span {
    background: #9880cb;
    color: #fff;
    width: auto !important;
    border-radius: 10px;
    display: inline-block;
    padding: 2px;
    font-weight: 300;
    font-size: 13px;
  }
  .sales-report .el-table th.is-leaf {
    font-size: 1.2em;
  }
  .sales-report .el-table th.is-leaf,
  .sales-report .el-table td {
    /* border-left: 1px solid #EBEEF5 !important; */
  }
  .sales-report th div, td div {
    overflow: inherit;
    overflow-wrap: inherit;
    text-overflow: ellipsis;
    word-break: normal !important;
  }
  .sales-report .custom-border {
    margin-bottom: 25px;
  }

  .checkbox-color input[type="checkbox"]:checked + label::before {
    background-color: #9880cb !important;
    border: 1px solid #9880cb !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/OrderStatus.vue